import { Component } from '@angular/core';

@Component({
  selector: 'app-categories-list-skeleton',
  templateUrl: './categories-list-skeleton.component.html',
  styleUrls: ['./categories-list-skeleton.component.scss']
})
export class CategoriesListSkeletonComponent {}
